// @ts-nocheck
import { Carousel } from '@xprog/prensa'
import { PageBlockTypes as p } from '@xprog/prensa/types'

import { teasers as T } from '../../../opopular/assets/teasers'

const renderWrapComponent = (data) => {
  return (
    <Carousel
      axis='horizontal'
      css={{
        carousel: {
          width: '100%'
        },
        container: {
          width: '100%'
        },
        root: {
          width: '100%',
          '.carousel.carousel-slider': {
            align: ['column', 'center', 'middle'],
            overflow: 'inherit',
            width: 'calc(100% - $8)'
          },
          '.carousel.carousel-slider .slider-wrapper': {
            overflow: 'inherit',
            width: '220px'
          }
        }
      }}
      labels={{
        item: '',
        leftArrow: 'Retroceder',
        rightArrow: 'Avançar'
      }}
      showArrows={false}
      showIndicators={false}
    >
      {data}
    </Carousel>
  )
}

export const LayoutPodcast: p.SlotConfigProps = {
  wrapperContent: {
    enabled: true,
    component: renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxPodcast: {
      slotLeft: {
        default: [T.TeaserPodcast, T.TeaserPodcast]
      }
    }
  }
}